import React from 'react';
import { useSelector } from 'react-redux';
import { StyledH3, StyledLabel, StyledP } from 'components';
import { AULink } from 'components/AULink';
import { customerLastNameSelector , customerFirstNameSelector , customerEmailSelector } from 'store/customer/selectors';
import { CHANGE_PASSWORD, EDIT_ACCOUNT } from 'constants/navigation';
import { ActionLabel, HeaderWrapper } from './styled';

export const AccountInformation = (): JSX.Element => {
  const firstName = useSelector(customerFirstNameSelector);
  const lastName = useSelector(customerLastNameSelector);
  const email = useSelector(customerEmailSelector);

  return (
    <>
      <HeaderWrapper underlined>
        <StyledH3 secondary>Account Information</StyledH3>
      </HeaderWrapper>
      <StyledLabel>Contact Information</StyledLabel>
      <StyledP secondary>{`${firstName} ${lastName}`}</StyledP>
      <StyledP secondary>{email}</StyledP>
      <>
        <ActionLabel>
          <AULink path={EDIT_ACCOUNT.url} id="edit-account">
            Edit
          </AULink>
        </ActionLabel>
        <ActionLabel>
          <AULink path={CHANGE_PASSWORD.url} id="change-password">
            Change Password
          </AULink>
        </ActionLabel>
      </>
    </>
  );
};
